<div class="text-container">
  <h1>{{ title }}</h1>
  <p class="description">
    {{ description }}
  </p>
  <ng-content></ng-content>
</div>
<img *ngIf="imgPath" [src]="imgPath" />
